import { CoreFormConsumerTypeEnum } from '../enums/';

export const CONSUMER_PROPS = {
  type: CoreFormConsumerTypeEnum.MANUAL,
  name: null
};
